export { isHostnameForHtmlEnvironment, isHostnameForBitrixEnvironment, getPublicPathForHtmlEnvironment };

function isHostnameForHtmlEnvironment(hostname) {
    return /^html.uplab.(digital|ru)$/.test(hostname);
}

function isHostnameForBitrixEnvironment(hostname) {
    return /^[a-z.-]+/.test(hostname) && !/^(local(host)?)|html\.uplab\.(digital|ru)$/.test(hostname);
}

function getPublicPathForHtmlEnvironment(pathname) {
    const index = pathname.indexOf('/dist/');
    return pathname.slice(0, index) + '/dist/';
}



// WEBPACK FOOTER //
// ./js/main/utils/utils.js